import { Col, Row } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';

import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';

import identifikaceEmitenta, { IIdentifikaceEmitenta } from 'services/akcionar/emise/identifikaceEmitenta';
import { IEmisniUdaje } from 'services/akcionar/emise/novyIsinSend';
import { IRozcestnikData } from 'services/akcionar/emise/rozcestnikISIN';
import { vyjadreniCdcpIsinApi } from 'services/spravaEmitenta/vyjadreniCdcp';

import { EEvidenceCp } from 'enums/isin/evidenceCp';
import { EDruhCp } from 'enums/isin/udaje/druhCp';

import IdentifikaceEmitentaNovy, { IRozcestnikInput } from './IdentifikaceEmitentaNovy';
import Rozcestnik from './RozcestnikNovy';
import UdajeEmise from './UdajeEmise';
import ZadostPosila from './ZadostPosila';

interface INovyISIN {}

const NovyISIN: React.FC<INovyISIN> = () => {
    const { isin, cisMeny, cisStaty } = useContext(Context);
    const prevStepRef = useRef(0);
    const [currentStep, setCurrentStep] = useState<number>(0);
    const [identifikacePutData, setIdentifikacePutData] = useState<IIdentifikaceEmitenta | undefined>();
    const [zadostID, setZadostID] = useState<number | undefined>(isin ? isin.idZadosti : 0);
    const [rozcestnikData, setRozcestnikData] = useState<IRozcestnikData['spolecnost']>();
    // const [zastupujeOsobaData, setZastupujeOsobaData] = useState<IIsinOsoba[] | undefined>();
    const [modalMessage, setModalMessage] = useState<string>('');
    const [rozcestnikInput, setRozcestnikInput] = useState<IRozcestnikInput | undefined>(
        isin
            ? {
                  emitentje: isin.emitentje || '',
                  ...(isin.emitentje && {
                      evidencecp: isin.evidencecp as EEvidenceCp
                  }),
                  podobacp: isin.podobacp || ''
              }
            : undefined
    );
    const [loading, setLoading] = useState<boolean>(false);
    const [druhCP, setDruhCP] = useState<EDruhCp | undefined>();
    const [udajeEmise, setUdajeEmise] = useState<IEmisniUdaje | undefined>();

    const next = () => {
        setCurrentStep(currentStep + 1);
    };

    const prev = () => {
        prevStepRef.current = currentStep;
        setCurrentStep(currentStep - 1);
    };

    useEffect(() => {
        if (isin && isin.stav === 'kdoplneni') {
            // zobrazi vyjadrenie cdcp v modale
            setLoading(true);
            vyjadreniCdcpIsinApi(isin.idZadosti ? isin.idZadosti : 0)
                .then(data => setModalMessage(data.vyjadreni))
                .finally(() => {
                    isin && setCurrentStep(1);
                    setLoading(false);
                });
        } else {
            isin && setCurrentStep(1); // ak je isin = rozpracovana ziadost => prejde na dalsiu stranu
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        identifikacePutData &&
            zadostID &&
            identifikaceEmitenta('POST', zadostID, {
                ...rozcestnikData,
                ...identifikacePutData
            }).then(() => {
                setLoading(false);
                currentStep === 1 && next();
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [identifikacePutData, zadostID]);

    const steps = [
        {
            title: '',
            content: (
                <Rozcestnik
                    cisStaty={cisStaty}
                    rozcestnikData={rozcestnikData}
                    setRozcestnikData={setRozcestnikData}
                    setRozcestnikInput={setRozcestnikInput}
                    setDruhCP={setDruhCP}
                    nextStep={next}
                    setZadostID={setZadostID}
                    zadostID={zadostID}
                    identifikacePutData={identifikacePutData}
                    rozcestnikInput={rozcestnikInput}
                    setIdentifikacePutData={setIdentifikacePutData}
                />
            )
        },
        {
            title: 'ISIN_IDENTIFIKACE_IDENTIFIKACE_EMITENTA',
            content: (
                <IdentifikaceEmitentaNovy
                    zadostID={zadostID}
                    // rozpracovanaZadost={!!isin}
                    modalMessage={modalMessage}
                    setModalMessage={setModalMessage}
                    rozcestnikData={rozcestnikData}
                    rozcestnikInput={rozcestnikInput}
                    prevStep={prev}
                    identifikacePutData={identifikacePutData}
                    setIdentifikacePutData={setIdentifikacePutData}
                />
            )
        },
        {
            title: 'ISIN_EMISE_UDAJ_NADPIS',
            content: (
                <UdajeEmise
                    cisMeny={cisMeny}
                    setIdentifikacePutData={setIdentifikacePutData}
                    identifikacePutData={identifikacePutData}
                    rozcestnikInput={rozcestnikInput}
                    nextStep={next}
                    prevStep={prev}
                    zadostID={zadostID}
                    druhCP={druhCP}
                    setDruhCP={setDruhCP}
                    setUdajeEmise={setUdajeEmise}
                    setRozcestnikInput={setRozcestnikInput}
                    udajeEmise={udajeEmise}
                    prevStepRef={prevStepRef.current}
                />
            )
        },
        {
            title: '',
            content: <ZadostPosila prevStep={prev} zadostID={zadostID} druhCP={druhCP} udajeEmise={udajeEmise} />
        }
    ];

    return (
        <LoadingWrapper loading={loading}>
            <Title level={3} text="FORMULARE_ZADOST_PRID" />
            <Title level={4} text={steps[currentStep].title} />
            <Row gutter={8}>
                <Col span={24}>{steps[currentStep].content}</Col>
            </Row>
        </LoadingWrapper>
    );
};

export default NovyISIN;
